import {
  Box,
  Heading,
  Image,
  SimpleGrid,
  Text,
  chakra,
  shouldForwardProp,
} from "@chakra-ui/react";
// import standingMe from './Files/Images/standingMe.png';
import standingMe from "../../Files/Images/standingMe.png";
import Styles from "./About.module.css";
import { motion, isValidMotionProp } from "framer-motion";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const About = () => {
  return (
    <Box
      id="about"
      className={Styles.about}
      width="100%"
      height={["750px", "900px", "750px"]}
    >
      <ChakraBox
        initial={{ opacity: 0 }}
        whileInView={{ y: [-15, 0], opacity: 1 }}
        transition={{
          duration: 1,
          delay: 0.3,
        }}
      >
        <SimpleGrid
          columns={[1, null, 2]}
          spacing="30px"
          height="700px"
          padding="5%"
        >
          <Box>
            <Image src={standingMe} alt="SVG" width="100%" height="100%" />
          </Box>
          <Box padding={"10px"} fontSize={["md", "xl"]}>
            <Heading as="h2" marginBottom={"10px"}>
              About Me ✍
            </Heading>
            <Text>
              I’m a Full Stack Engineer who enjoys building responsive,
              user-friendly web apps and solving real-world problems with clean,
              scalable code. Skilled in React, TypeScript, Node.js, NestJS,
              GraphQL, and AWS, I love learning new technologies and improving
              my craft. Outside of coding, you’ll often find me on the football
              field ⚽ or exploring new ideas in tech.
            </Text>
            {/* <UnorderedList textAlign="left">
              <ListItem>
                I am a passionate web developer who loves to solve real life
                problems & learn new things specially related to web development{" "}
              </ListItem>
              <Spacer />
              <ListItem>
                I'm skilled in both Frontend & Backend technologies with immense
                desire & motivation to work & excel as Full Stack web developer.
              </ListItem>
              <Spacer />
              <ListItem>
                Building responsive Front-End website using ReactJS
              </ListItem>
              <Spacer />
              <ListItem>I love to play Football</ListItem>
            </UnorderedList> */}
          </Box>
        </SimpleGrid>
      </ChakraBox>
    </Box>
  );
};

export default About;
